import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "ubd-learning-standards",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/routes/MYPAcademicSetup/routes/LearningStandards/modules/Module"
        ),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const multiLevelNodeEditorReducer = importedModule2.default;
        injectReducer(store, {
          key: "learningStandards",
          reducer,
        });
        injectReducer(store, {
          key: "multiLevelNodeEditor",
          reducer: multiLevelNodeEditorReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
